import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { AiOutlineDownload } from "react-icons/ai";
import PageTransition from "../components/PageTransition";
import AnimatedSection from "../components/AnimatedSection";

import Particle from '../components/Particle'
import pdf from "../assets/resume.pdf"
import Chatbot from '../components/Chatbot'

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const resumeLink = pdf;

const Resume = () => {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <PageTransition>
      <div>
        <Container fluid className="resume-section">
          <Particle />
          
          <AnimatedSection direction="up" delay={0.1}>
            <Row style={{ justifyContent: "center", position: "relative", marginBottom: "30px" }}>
              <Button
                variant="primary"
                href={pdf}
                target="_blank"
                style={{ maxWidth: "250px" }}
              >
                <AiOutlineDownload />
                &nbsp;Download Resume
              </Button>
            </Row>
          </AnimatedSection>

          <Row className="resume">
            <AnimatedSection direction="up" delay={0.2} className="d-flex justify-content-center">
              <Document file={resumeLink} className="d-flex justify-content-center">
                <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
              </Document>
            </AnimatedSection>
          </Row>

          <AnimatedSection direction="up" delay={0.3}>
            <Row style={{ justifyContent: "center", position: "relative", marginTop: "30px" }}>
              <Button
                variant="primary"
                href={pdf}
                target="_blank"
                style={{ maxWidth: "250px" }}
              >
                <AiOutlineDownload />
                &nbsp;Download Resume
              </Button>
            </Row>
          </AnimatedSection>
        </Container>
        <Chatbot />
      </div>
    </PageTransition>
  )
}

export default Resume
